import React from 'react';
import CircularProgress from 'material-ui/CircularProgress';
import styled from 'styled-components';


const Container = styled.div`
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10000;
  background: rgba(255,255,255,.75);
  position: fixed;

`

const Loading = () => (
  <Container>
    <CircularProgress size={60} thickness={5} 
      style={{position: 'absolute', left: '50%', top: '50%', marginTop: '-30px', marginLeft: '-30px'}}/>
  </Container>
)

export default Loading;






// WEBPACK FOOTER //
// ./src/components/Loading.js